import React from 'react'
import {DatasetInfo} from '@/generated/graphql'
import {Grid, Paper, TableCell, TableRow, Typography} from '@mui/material'
import styled from 'styled-components'
import {LockPerson, Public} from '@mui/icons-material'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import {omitDeep} from '@apollo/client/utilities'
import {
    StyledChip,
    StyledFilterContainer,
    StyledInlineContainer,
    StyledInlineDiv, StyledJsonPreview, StyledSpaceBetweenDiv
} from '@/components/common/CustomStyledComponents'

const StyledTableHeadCell = styled(TableCell)`
    background-color: ${ThemeColorsHospitalic.PRIMARY_LIGHT} !important;
    font-weight: bolder;
`

type DatasetDetailContentProps = {
    dataset?: DatasetInfo;
}

const DatasetDetailContent = ({dataset}: DatasetDetailContentProps) => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid size={8}>
                    <StyledSpaceBetweenDiv>
                        <Typography fontWeight="bolder">Name: {dataset?.dataset_name}</Typography>
                        <StyledChip icon={dataset?.public ? <Public/> : <LockPerson/>}
                            label={dataset?.public ? 'PUBLIC' : 'PRIVATE'}/>
                    </StyledSpaceBetweenDiv>
                    <StyledInlineContainer>
                        <StyledInlineDiv>
                            <Typography fontWeight="bolder">Version:</Typography>
                            <Typography>{dataset?.version}</Typography>
                        </StyledInlineDiv>
                        <StyledInlineDiv>
                            <Typography fontWeight="bolder">Parent DB ID:</Typography>
                            <Typography>{dataset?.parent_database_id}</Typography>
                        </StyledInlineDiv>
                        <StyledInlineDiv>
                            <Typography fontWeight="bolder">Reference genome:</Typography>
                            <Typography>{dataset?.reference_genome}</Typography>
                        </StyledInlineDiv>
                    </StyledInlineContainer>
                    <StyledInlineContainer>
                        <TableContainer sx={{ width: 'fit-content', borderRadius: '16px 16px 0 0', borderCollapse: 'collapse', boxShadow: '4px 4px 16px rgba(0, 0, 0, 0.12)' }} component={Paper}>
                            <Table stickyHeader size="small" sx={{width: 'auto', tableLayout: 'auto'}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableHeadCell>Gene Count</StyledTableHeadCell>
                                        <StyledTableHeadCell>Variant Count</StyledTableHeadCell>
                                        <StyledTableHeadCell>Transcript Count</StyledTableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell size="small">{dataset?.gene_count}</TableCell>
                                        <TableCell>{dataset?.variant_count}</TableCell>
                                        <TableCell>{dataset?.transcript_count}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </StyledInlineContainer>
                    <StyledInlineContainer>
                        <Typography fontWeight="bolder">Description:</Typography>
                    </StyledInlineContainer>
                    <StyledInlineContainer>
                        <Typography>{dataset?.description}</Typography>
                    </StyledInlineContainer>
                </Grid>
                <Grid size={4}>
                    <StyledFilterContainer>
                        <Typography variant='h5'>Applied Filter</Typography>
                        {dataset?.filter_applied &&
                            <StyledJsonPreview>{JSON.stringify(omitDeep(dataset.filter_applied, '__typename'), null, 1)}</StyledJsonPreview>}
                    </StyledFilterContainer>
                </Grid>
            </Grid>
        </>
    )
}

export default DatasetDetailContent